import React from 'react'
import AdminDashboard from '../../components/admin/Dashboard'

function AdminHome() {
  return (
   <>
    <AdminDashboard/>
   </>
  )
}

export default AdminHome
